import React, { Component } from 'react';
import { intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { change, Field, formValueSelector, getFormInitialValues, reduxForm, getFormSyncErrors } from 'redux-form';
import { connect } from 'react-redux';
import TextField from '../../../shared-components/TextField/TextField';
import { expandAddress, collapseAddressImmediately, collapseAddressSlowly, forceFocus } from './CollapsibleAddressFieldsActions';
import { FORM_ID, COUNTRY } from '../../../framework/App/AppConstants';
import {ADDRESS_COLLAPSED, ADDRESS_COLLAPSING, ADDRESS_EXPANDED} from './CollapsibleAddressFieldsConstants';
import Street1 from '../../../shared-components/AddressComponent/Street1/Street1';
import PostalCode from '../../../shared-components/AddressComponent/PostalCode/PostalCode';
import City from '../../../shared-components/AddressComponent/City/City';
import ROW from '../../../shared-components/VXGrid/Row';
import COL from '../../../shared-components/VXGrid/Col';
import _ from 'lodash';
import './CollapsibleAddressFields.less';

const LOCALE_PREFIX_ADDRESS = 'DE/components/Address/Address';

export class CollapsibleAddressFields extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        country: PropTypes.oneOf(Object.values(COUNTRY)).isRequired,
        collapseSlowly: PropTypes.func,
        collapseImmediately: PropTypes.func,
        expandAddress: PropTypes.func,
        showAddress: PropTypes.string,
        fullAddress: PropTypes.string,
        formSyncErrorsObj: PropTypes.object
    };

    showExpandedAddressFields = (event) => {
        const { expandAddress } = this.props;
        expandAddress();
        forceFocus('street1');
    };
    showCollapsedAddressField = (event) => {
        const { collapseImmediately, formSyncErrorsObj } = this.props;
        setTimeout(() => {
            const id = document.activeElement && document.activeElement.getAttribute('id');
            if (id !== 'street1' && id !== 'city' && id !== 'postalCode'
                && !formSyncErrorsObj['city'] && !formSyncErrorsObj['street1'] && !formSyncErrorsObj['postalCode']) {
                collapseImmediately();
            }
        });
    };

    addressCollapsed() {
        const { fullAddress, intl } = this.props;
        const input = {
            value: fullAddress,
            onFocus: this.showExpandedAddressFields,
            onChange: this.showExpandedAddressFields
        };

        return (
            <Field
                key="short"
                id="fullAddress"
                name="fullAddress"
                label={intl.formatMessage({id: `${LOCALE_PREFIX_ADDRESS}.address`})}
                component={TextField}
                input={input}
            />
        );
    }

    addressExpanded() {
        const { country } = this.props;
        const inputProps = {
            onBlur: this.collapseImmediately
        };
        return (
            <fieldset className="collapsibleAddressFields" onBlur={this.showCollapsedAddressField}>
                <ROW gutterSize={0}>
                    <COL xs={12}>
                        <div className="street1">
                            <Street1 localePrefix={LOCALE_PREFIX_ADDRESS} />
                        </div>
                    </COL>
                </ROW>
                <ROW gutterSize={0}>
                    <COL xs={4}>
                        <PostalCode localePrefix={LOCALE_PREFIX_ADDRESS} country={country} />
                    </COL>
                    <COL xs={8}>
                        <City localePrefix={LOCALE_PREFIX_ADDRESS} validateCity={false} />
                    </COL>
                </ROW>
            </fieldset>
        );
    }

    render() {
        const { showAddress } = this.props;
        let content;

        switch (showAddress) {
            case ADDRESS_EXPANDED:
                content = this.addressExpanded();
                break;
            case ADDRESS_COLLAPSED:
            default:
                content = this.addressCollapsed();
                break;
        }

        return (
            <div>
                { content }
            </div>
        );
    }
}

export const mapDispatchToProps = dispatch => ({
    expandAddress() {
        dispatch(expandAddress());
    },
    collapseSlowly() {
        dispatch(collapseAddressSlowly());
    },
    collapseImmediately() {
        dispatch(collapseAddressImmediately());
    }
});

export const mapStateToProps = (state) => {
    const selector = formValueSelector(FORM_ID);
    const street1 = selector(state, 'street1');
    const city = selector(state, 'city');
    const postalCode = selector(state, 'postalCode');
    const formSyncErrors = getFormSyncErrors(FORM_ID)(state);

    return {
        showAddress: _.get(state, 'CollapsibleAddressFields.showAddress'),
        country: _.get(state, 'serverData.country'),
        fullAddress: `${street1}, ${postalCode}, ${city}`,
        formSyncErrorsObj: formSyncErrors
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CollapsibleAddressFields));
